module.exports = __webpack_public_path__ + "img/accounting_color.bfd464c9.png";